// extracted by mini-css-extract-plugin
export default {"timeDisplay":"MOLIdleTime_timeDisplay__OlvKR","timerText":"MOLIdleTime_timerText__wAm2P"};